import script from "./NewsApp.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsApp.vue?vue&type=script&setup=true&lang=js"

import "./NewsApp.vue?vue&type=style&index=0&id=33971d58&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33971d58"]])

export default __exports__